import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton, Typography } from '@mui/material';
import Styles from '../Config/Styles';
const Backbutton = ({ onClick }) => {
    return (
        <Box sx={Styles.backbtn.box}>
            <IconButton size="small" onClick={onClick}>
                <ArrowBackIcon />
                <Typography variant="body2" sx={Styles.backbtn.Typo}>
                    Back
                </Typography>
            </IconButton>
        </Box>
    )
}

export default Backbutton